import { useSuperQuery } from '@vadiun/react-hooks-legacy';
import { useState } from 'react';
import { StagesState } from 'shared/models/Stages';
import { SortState } from 'shared/models/tabletReactQuery';
import { stagesService } from 'shared/services/shared/stagesService';

export const getDefaultSortStages = (): SortState => ({
  sortDir: 'DESC',
  sortBy: 'updated_at',
});

export const getDefaultStagesState = (): StagesState => ({
  page: 1,
  rowsPerPage: 10,
  sort: getDefaultSortStages(),
});

export const useStagesOfReserveStates = () => {
  const StagesService = stagesService();
  const [state] = useState<StagesState>(getDefaultStagesState());

  const getStages = useSuperQuery(
    () =>
      StagesService.getAll(
        state.page,
        state.rowsPerPage,
        state.sort.sortBy,
        state.sort.sortDir,
      ),
    {
      showSpinner: true,
    },
    [state.page, state.rowsPerPage, state.sort.sortBy, state.sort.sortDir],
  );

  return {
    stagesOfReserveStates: {
      data: getStages.data?.rows || [],
      total: getStages.data?.total || 0,
      isLoading: getStages.isLoading,
      error: getStages.error,
      reload: getStages.reload,
      serverSideOptions: {
        page: state.page - 1,
        count: getStages.data?.total || 0,
        rowsPerPage: state.rowsPerPage,
        sortOrder: {
          name: state.sort.sortBy,
          direction: state.sort.sortDir.toLowerCase() as 'asc' | 'desc',
        },
      },
    },
  };
};

